import type * as React from 'react';

import { divider } from './style';

interface DividerProps {
  vertical?: boolean;
  className?: string;
}

export const Divider: React.FC<DividerProps> = ({ vertical, className }) => {
  return <hr className={`${divider(vertical)} ${className || ''}`} />;
};
